module.exports = __webpack_public_path__ + "img/recoleta_thumb.efdb3498.jpg";